'use strict';

angular.module('ecrd.records', [
    'ecrd.record.bulk',
    'sharecrf-sdk',
    'sharecrf.loading',
]);
